
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ContactForm from './components/ContactForm';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const servicesPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${SITE_URL}/services#webpage`,
  url: `${SITE_URL}/services`,
  name: 'Concrete Pumping & Stone Services | LG Concrete Pumping Otto NC',
  description:
    'Explore all concrete pumping and stone services offered by LG Concrete Pumping & Stone LLC in Otto, NC — including concrete pumping, stone installation, block filling, and custom masonry.',
  isPartOf: { '@id': `${SITE_URL}/#website` },
  provider: { '@id': `${SITE_URL}/#business` },
};

const serviceListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'LG Concrete Pumping Services',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Concrete Pumping', url: `${SITE_URL}/services/concrete-pumping` },
    { '@type': 'ListItem', position: 2, name: 'Stone Services', url: `${SITE_URL}/services/stone-services` },
    { '@type': 'ListItem', position: 3, name: 'Block Filling', url: `${SITE_URL}/services/block-filling` },
    { '@type': 'ListItem', position: 4, name: 'Custom Masonry', url: `${SITE_URL}/services/custom-masonry` },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
  ],
};

const ServicesPage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    [servicesPageSchema, serviceListSchema, breadcrumbSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Concrete Pumping & Stone Services | LG Concrete Pumping Otto NC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Explore all concrete pumping and stone services offered by LG Concrete Pumping & Stone LLC in Otto, NC — including concrete pumping, stone installation, block filling, and custom masonry.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/services`);

    return () => { scripts.forEach((s) => s.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <ServicesHero />
        <ServicesList />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
